import React from 'react';

import StepsList from './StepsList';
import ConditionsPlacementControl from './ConditionsPlacementControl';

import './ConditionsTopPanel.scss';

const ConditionsTopPanel = ({
  placement,
  setPlacement,
  setIsShown,
  steps,
  activeStep,
  setActiveStep,
  resized,
  onActiveStepChange,
  routeType,
}) => {
  return (
    <div className="project-route-conditions-top-panel rx-flex-row-container">
      <StepsList
        steps={steps}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        resized={resized}
        onActiveStepChange={onActiveStepChange}
        routeType={routeType}
      />
      <ConditionsPlacementControl placement={placement} setPlacement={setPlacement} setIsShown={setIsShown} />
    </div>
  );
};

export default ConditionsTopPanel;
